import React from 'react'
import { tokens } from '../../styles/tokens'
import { ActiveOrdersTile, useSegmentTrackStyles } from './ActiveOrdersTile'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { Pages } from '../../router/router'
import { sortTradeDiaryTable } from '../../redux/actions/filterActions'
import { TraderDiaryByStateOptions } from '../../redux/reducers/filters'
import {
  TRADER_DIARY_CANCELED,
  TRADER_DIARY_PARTIAL_SETTLED,
  TRADER_DIARY_RECEIVED,
  TRADER_DIARY_SETTLED,
} from '../../constants/codeLists'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from '../../redux/hooks/useSelector'

export const TraderDiaryTiles = () => {
  const trackClasses = useSegmentTrackStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { clientId } = useParams<{ clientId: string }>()
  const { t } = useTranslation()
  const traderDiaries = useSelector(state => state.traderDiaries.traderDiaries)
  const filters = useSelector(state => state.filters)

  const onStateClick = (countState: TraderDiaryByStateOptions) => () => {
    if (clientId === null || clientId === undefined) history.push(Pages.TraderDiary)

    dispatch(sortTradeDiaryTable(countState))
  }

  const countBy = (state?: string) =>
    traderDiaries && traderDiaries.length > 0
      ? state
        ? traderDiaries.filter(item => item.state === state).length
        : traderDiaries.length
      : '?'

  const segments = [
    {
      label: t('ALL'),
      count: countBy(),
      option: TraderDiaryByStateOptions.All,
      dot: undefined as string | undefined,
    },
    {
      label: t('RECEIVED'),
      count: countBy(TRADER_DIARY_RECEIVED),
      option: TraderDiaryByStateOptions.Received,
      dot: tokens.color.primary[300],
    },
    {
      label: t('SETTLED'),
      count: countBy(TRADER_DIARY_SETTLED),
      option: TraderDiaryByStateOptions.Settled,
      dot: tokens.color.success[500],
    },
    {
      label: t('PARTIAL_SETTLED'),
      count: countBy(TRADER_DIARY_PARTIAL_SETTLED),
      option: TraderDiaryByStateOptions.PartialSettled,
      dot: tokens.color.warning[500],
    },
    {
      label: t('CANCELED'),
      count: countBy(TRADER_DIARY_CANCELED),
      option: TraderDiaryByStateOptions.Canceled,
      dot: tokens.color.neutral[400],
    },
  ]

  return (
    <div className={trackClasses.track}>
      {segments.map(segment => (
        <ActiveOrdersTile
          key={segment.option}
          label={segment.label}
          count={segment.count}
          dot={segment.dot}
          selected={filters.sortTraderDiaryBy === segment.option}
          onClick={onStateClick(segment.option)}
        />
      ))}
    </div>
  )
}
